import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24374712"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ending" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))

import UIPanelEndSuccess from '@/components/UIPanelEndSuccess/UIPanelEndSuccess.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "long-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(UIPanelEndSuccess, { class: "panel" })
      ])
    ]),
    _: 1
  }))
}
}

})